import { Directive, ElementRef, Input, Renderer2, HostListener } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[appTruncateTooltip]',
  providers: [NgbTooltip],
})
export class TruncateTooltipDirective {
  @Input('appTruncateTooltip') tooltipText: string;

  constructor(private el: ElementRef, private ngbTooltip: NgbTooltip, private renderer: Renderer2) {}

  @HostListener('mouseenter') onMouseEnter() {
    this.updateTooltip();
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.ngbTooltip.close();
  }

  private updateTooltip() {
    if (this.isTextTruncated()) {
      this.ngbTooltip.ngbTooltip = this.tooltipText;
      this.ngbTooltip.open();
      this.renderer.setAttribute(this.el.nativeElement, 'title', this.tooltipText); // Fallback para tooltip
    } else {
      this.ngbTooltip.close();
      this.renderer.removeAttribute(this.el.nativeElement, 'title'); // Elimina el fallback si no está truncado
    }
  }

  private isTextTruncated(): boolean {
    const element = this.el.nativeElement;
    return element.scrollWidth > element.clientWidth;
  }
}
